import usePostData from '../../../../../hooks/postHook';

export const useAddUser = ({ id }) => {
  const [{ data, isLoading, isError, error }, doAddUser] = usePostData(
    `admin_brand/${id}/clients`
  );

  return { data, isLoading, isError, error, doAddUser };
};
